import React from 'react'
import ApiKeys from "../../ApiKeys/ApiKeys"
const ApiKeysdiv = () => {
  return (
    <div>
      <ApiKeys/>
    </div>
  )
}

export default ApiKeysdiv
